import React from "react";
import { Paper, Typography, Grid } from "@material-ui/core";
import { Link } from "react-router-dom";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import TrendingUpIcon from "@material-ui/icons/TrendingUp";

const formatNumber = (num) => {
    if (num === undefined || num === null) return "0";
    return num.toLocaleString();
};

const formatCurrency = (num) => {
    if (num === undefined || num === null) return "$0";
    return "$" + num.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

const AdminStatCard = ({ 
    title, 
    total, 
    newCount, 
    newLabel = "new this period", 
    link, 
    color = "#ff0c9c",
    large = false,
    isCurrency = false
}) => {
    const displayTotal = isCurrency ? formatCurrency(total) : formatNumber(total);
    const displayNew = isCurrency ? formatCurrency(newCount) : formatNumber(newCount);

    return (
        <Paper 
            style={{ 
                padding: large ? 24 : 16, 
                height: "100%",
                position: "relative",
                overflow: "hidden"
            }}
        >
            <div
                style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: 4,
                    height: "100%",
                    backgroundColor: color
                }}
            />
            <Grid container direction="column" spacing={8}>
                <Grid item>
                    <Typography 
                        variant="caption" 
                        style={{ 
                            color: "#666",
                            textTransform: "uppercase",
                            fontWeight: 600,
                            letterSpacing: 0.5
                        }}
                    >
                        {title}
                    </Typography>
                </Grid>
                <Grid item>
                    <Typography 
                        variant={large ? "h4" : "h5"} 
                        style={{ 
                            color: "#262626",
                            fontWeight: 700
                        }}
                    >
                        {displayTotal}
                    </Typography>
                </Grid>
                <Grid item>
                    <Grid container alignItems="center" spacing={4}>
                        <Grid item>
                            <TrendingUpIcon style={{ color: "#4caf50", fontSize: 16 }} />
                        </Grid>
                        <Grid item>
                            <Typography 
                                variant="body2" 
                                style={{ color: "#4caf50", fontWeight: 500 }}
                            >
                                +{displayNew}
                            </Typography>
                        </Grid>
                        <Grid item>
                            <Typography 
                                variant="caption" 
                                style={{ color: "#999" }}
                            >
                                {newLabel}
                            </Typography>
                        </Grid>
                    </Grid>
                </Grid>
                {link && (
                    <Grid item style={{ marginTop: 8 }}>
                        <Link 
                            to={link} 
                            style={{ 
                                color: color,
                                textDecoration: "none",
                                display: "flex",
                                alignItems: "center",
                                fontSize: 14,
                                fontWeight: 500
                            }}
                        >
                            View Details
                            <ArrowForwardIcon style={{ fontSize: 16, marginLeft: 4 }} />
                        </Link>
                    </Grid>
                )}
            </Grid>
        </Paper>
    );
};

export default AdminStatCard;
